<!--
component is not used
-->
<template>
  <b-modal
    id="delete-contact-modal"
    ref="deleteModal"
    modal-class="delete-contact-modal"
    centered
    :hide-header-close="true"
    size="sm">
    <template slot="modal-title">
      Delete contacts
    </template>
    <div class="text-center">
      <h5 v-if="unselectedSingleContactData">
        Are you sure you want to delete contact
        <strong>{{ unselectedSingleContactData.name ? '"' + unselectedSingleContactData.name + '"' : '' }}</strong>
        with number
        <strong>{{ unselectedSingleContactData.phone }}</strong>?
      </h5>
      <h5 v-else>
        Are you sure you want to delete {{ multipleSelect ? `${contactsToDelete} contacts` : 'this contact' }}?
      </h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Cancel
      </b-button>
      <b-button
        variant="danger"
        :disabled="deleting"
        @click="commitDelete">
        Delete
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DeleteModal',
  props: {
    contactIds: {
      type: Array,
      default: () => [],
    },
    deleteAll: {
      type: Boolean,
      default: false,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      deleting: false,
      unselectedSingleContactData: null,
    };
  },
  computed: {
    ...mapGetters({
      contactDeleted: 'contact/contactDeleted',
      apiError: 'contact/apiError',
    }),
    multipleSelect() {
      if (this.unselectedSingleContactData) {
        return true;
      }
      return this.deleteAll ? this.totalCount > 1 : this.contactIds.length > 1;
    },
    contactsToDelete() {
      return this.deleteAll ? this.totalCount : this.contactIds.length;
    },
  },
  watch: {
    contactDeleted(deleted) {
      if (deleted) {
        this.deleting = false;
        this.$emit('deleted', deleted);
        this.$refs.deleteModal.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteContact: 'contact/deleteContact',
      deleteContacts: 'contact/deleteContacts',
    }),
    commitDelete() {
      this.deleting = true;
      const deleteParams = {
        merchant_id: this.$route.params.merchant_id,
        data: {},
      };

      if (this.deleteAll) {
        deleteParams.data.delete_all = true;
      } else {
        deleteParams.data.contact_ids = this.contactIds;
      }

      this.deleteContacts(deleteParams);
    },
    show() {
      this.$refs.deleteModal.show();
    },
    showForOne(contactData) {
      this.unselectedSingleContactData = contactData;
      this.$refs.deleteModal.show();
    },
    hide() {
      this.deleting = false;
      this.unselectedSingleContactData = null;
      this.$refs.deleteModal.hide();
    },
  },
};
</script>
<style lang="scss">
.delete-contact-modal {
  .modal-body {
    background-color: #f8fafb;
    border-top: 1px solid $greyBorderModal;
    border-bottom: 1px solid $greyBorderModal;

    strong {
      font-weight: bold;
    }
  }
}
</style>
